<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список полисов"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-certificate"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Страховые полисы
        </div>
      </template>
      <v-card-text>
        <v-data-table
          :headers="headers.filter(a=>choose || a.value!='selected')"
          :items="items"
          @click:row="row_click"
          :items-per-page="choose?5:10"
          :footerProps="datatable_footer"
          :server-items-length="total"
          :options.sync="table_options"
          :loading="loading"
        >
         <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
          <template v-slot:top>
            <v-card flat>
              <v-card-text>
                <v-form v-model="valid">
                <v-row>                 
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.vin"
                      label="VIN"
                      @keyup.enter="load"
                      :rules="[ v=> v.length >= 3 || v.length === 0 || 'Минимум 3 символа']"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.doc.number"
                      label="Номер полиса"
                      @keyup.enter="load"
                      :rules="[ v=> v.length >= 3 || v.length === 0 || 'Минимум 3 символа']"
                    />
                  </v-col>
                   <v-col cols="3">
                    <v-text-field
                      v-model="form.phone"
                      label="Номер телефона"
                      @keyup.enter="load"
                       :rules="[ v=> v.length >= 6 || v.length === 0 || 'Минимум 6 символов']"
                      />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="form.number"
                      label="Гос. номер"
                      @keyup.enter="load"
                      :rules="[ v=> v.length >= 3 || v.length === 0 || 'Минимум 3 символа']"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.name"
                      label="ФИО"
                      @keyup.enter="load"
                      :rules="[ v=> v.length >= 3 || v.length === 0 || 'Минимум 3 символа']"
                    />
                  </v-col>                
                  <v-col cols="2">
                    <v-btn
                      color="green"
                      class="mb-2"
                      @click="show_insurance_create_dialog"
                      dark
                    >
                      <span class="mx-5">Создание</span>
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 ml-5"
                      @click="load"
                      :disabled="!valid || (form.vin == '' && form.name =='' && form.number =='' && form.phone =='' && form.doc.number == '')"
                    >
                      <span class="mx-5">Поиск</span>
                    </v-btn>
                  </v-col>
                </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </template>
          <template v-slot:item.vehicle="{item}">
            <div v-if="item.vehicle_item">
              {{ item.vehicle_item.model }}<br>
              <font color="#db7093">{{ item.vehicle_item.number }}<br></font>
              <font color="blue">{{ item.vehicle_item.date }}</font>
            </div>
            <div>
              {{item.object}}
            </div>
          </template>
          <template v-slot:item.selected="{item}">
            <v-checkbox
              v-if="choose"
              v-model="item.selected"
            />
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon
              large
              color="primary"
              class="mr-2"
              @click="show_insurance_view_dialog(item)"
            >
              mdi-cog
            </v-icon>
          </template>
          <template v-slot:item.user="{item}">
            <span v-if="item.user">{{item.user.name}}</span>
            <span v-else>Система</span>
          </template>
          <template v-slot:item.information="{ item }">
            <span v-if="item.created"> {{ format(item.created)}}</span><br>
            {{dict.insurance_state[item.state]}}<br>
            <span v-if="item.user">{{formatName(item.user)}}</span>
            <span v-else>Система</span>
          </template>
          <template v-slot:item.doc="{ item }">
            <span v-if="item.insurer>0">
              {{ item.insurer_text }}<br>
              <font  v-if="dict.insurance_product[item.product]" :color="dict.insurance_product_color[item.product]">{{ dict.insurance_product[item.product]}}<br></font>
              {{ item.doc.series }} {{ item.doc.number }}
            </span>
          </template>
          <template v-slot:item.date="{item}">
            <span v-if="item.doc && item.doc.from_date"> {{ format(item.doc.from_date)}}</span><br>
            <span v-if="item.doc && item.doc.date"> {{ format(item.doc.date)}}</span>
          </template>
          <template v-slot:item.insurer="{item}">
            <span v-if="item.insurant_item">
              <font :color="item.insurant_item.office?'green':'black'">{{ item.insurant_item.surname }} {{ item.insurant_item.name }} {{ item.insurant_item.patronymic }}<br></font>
            </span>
          </template>
          <template v-slot:item.sum="{item}">
            <v-chip v-if="item.sum" :color="item.revenue ? 'green' : 'blue'">
              {{ item.sum }}<br>
            </v-chip>
            <v-chip v-if="item.sum_to">
              {{ item.sum_to }}<br>
            </v-chip>
          </template>
          <template v-slot:item.widget="{item}">
            <v-menu
              :close-on-content-click="false"
              width="320"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ma-2" text icon color="blue" :disabled="(!item.events || item.events.length <= 0)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-calendar-search</v-icon>
                </v-btn>
              </template>
              <v-card
                title="События"
              >
                <v-card-text>
                  <div
                    v-for="(event,index) in item.events"
                    :key="index"
                    style="cursor: pointer"
                  >
                    <v-row @click="show_insurance_view_dialog(item, index)" class="select_row">
                      <v-col cols="2">
                        <v-icon large :color="event.color" v-if="$store.state.dict.events[event.type]">{{ $store.state.dict.events[event.type].icon }}</v-icon>
                      </v-col>
                      <v-col cols="4">
                        <font :color="event.color" v-if="$store.state.dict.events[event.type]">{{ $store.state.dict.events[event.type].name }} {{ event.start }}<br></font>
                        <font color="#db7093"><span v-if="event.user">{{ event.user_item.surname }} {{ event.user_item.name }} {{ event.user_item.patronymic }}</span><br></font>
                        <b>{{dict.state[event.state]}}</b>
                        
                      </v-col>
                      <v-col cols="6">
                        <font color="blue">{{event.text}}</font>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-menu
              :close-on-content-click="false"
              width="320"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ma-2" text icon color="success" :disabled="(!item.comments || item.comments.length <= 0)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-comment-search</v-icon>
                </v-btn>
              </template>
              <v-card
                title="Комментарии"
              >
                <v-card-text>
                  <v-list-item
                    v-for="(comment,comment_index) in item.comments"
                    :key="'com_' + comment_index"
                    two-line             
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{comment.text}}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <span v-if="comment.creator">{{ comment.creator.surname }} {{ comment.creator.name }} {{ comment.creator.patronymic }}</span>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <b>{{ format_full(comment.created) }}</b>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="2" v-if="choose && multiple">
            <v-btn
              color="secondary"
              min-width="200"
              @click="$emit('close')"
            >
              Назад
            </v-btn>
          </v-col>
          <v-col cols="2" v-if="$store.state.user.role == 1 || $store.state.user.role == 6">
            <v-btn
              color="primary"
              min-width="200"
              @click="dialog.event_group.show = true"
            >
              <span class="mx-5">Формирование заданий на обзвон</span>       
            </v-btn>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn
              v-if="choose && multiple"
              color="success"
              min-width="200"
              @click="$emit('select', items.filter(a=>a.selected))"
            >
              Выбрать
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </base-material-card>
    <v-dialog v-model="dialog.insurance.show" persistent>
      <InsuranceForm
        :create="dialog.insurance.create"
        :view="dialog.insurance.view"
        :change="dialog.insurance.change"
        :show="dialog.insurance.show"
        :data="dialog.insurance.data"
        :index="dialog.insurance.index"
        :vehicle="vehicle"
        @close="insurance_close"
      />
    </v-dialog>
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load()"
      />
    </v-dialog>
    <v-dialog v-model="dialog.event_group.show" max-width=600 persistent>
      <v-card>
        <v-card-title>Формирование заданий на обзвон</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field
                type="number"
                label="Период формирование"
                v-model="dialog.event_group.period"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="date"
                label="Дата начала выдачи заданий"
                v-model="dialog.event_group.date"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="time"
                label="Интервал между заданиями"
                v-model="dialog.event_group.interval"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="dialog.event_group.users"
                :items="select.users.filter(a=>a.kind == 0 && (a.role == 3 || a.role == 6))"
                label="Пользователи"
                item-value="id"
                item-text="full_name"
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            @click="dialog.event_group.show = false"
          >
            <span>Назад</span>
          </v-btn>
          <v-btn
            color="primary"
            @click="create_insurance_events"
          >
            <span class="mx-5">ОК</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import EventForm from './EventForm'
  export default {
    name: 'DashboardDataTables',
    props: ['show','choose', 'multiple', 'vehicle'],
    components: { EventForm },
    data: () => ({
      valid: false,
      loading: false,
      table_options: {

      },
      total: 0,
      overlay: false,
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      headers: [
        {
          text: 'Действие',
          value: 'action',
        },
        {
          text: 'Информация',
          value: 'information',
        },
        {
          text: 'Полис',
          value: 'doc',
        },
        {
          text: 'Период действия',
          value: 'date',
        },
        {
          text: 'Страхователь',
          value: 'insurer',
        },
        {
          text: 'Объект страхования',
          value: 'vehicle',
        },
        {
          text: 'Страховая премия\\ТО',
          value: 'sum',
        },
        {
          text: 'Виджеты',
          value: 'widget',
        },
        {
          text: 'Выбран',
          value: 'selected'
        }
      ],
      dialog: {
        insurance: {
          show: false,
          create: false,
          change: false,
          view: false,
          data: {},
        },
        event: {
          show: false,
          create: false,
          change: false,
          view: false,
          item: {},
          data: {},
        },
        event_group: {
          show: false,
          period: 0,
          date: moment().add(1, 'days').format('YYYY-MM-DD'),
          interval: '00:30'
        }
      },
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        created: {
          from: '',
          to: '',
        },
        doc: {
          series: '',
          number: '',
        },
        vin: '',
        name: '',
        phone: '',
        number: '',
        revenue: false,
        all: false
      },
      select: {
        insurer: [],
        user: [],
        users: [],
        insurance_state: [
          {value: 0, text: 'Клиентский'},
          {value: 1, text: 'Оформление Евроком'},
          {value: 2, text: 'Пролонгирован'},
          {value: 3, text: 'Клиент продал ТС'},
          {value: 4, text: 'Отказ от страхования'},
          {value: 5, text: 'Застрахован в другом месте'}
        ],
        insurance_product: []
      },
      dict: {
        insurance_state: {
          0: 'Клиентский',
          1: 'Оформление Евроком',
          2: 'Пролонгирован',
          3: 'Клиент продал ТС',
          4: 'Отказ от страхования',
          5: 'Застрахован в другом месте'
        },
        state: {
          1: 'Новый',
          2: 'Завершен',
          3: 'Отменен',
        },
        insurance_product: {},
        insurance_product_color: {}
      }
    }),
    watch: {
      'show': function() {
        if (this.show) {
          //this.load()
        }
      },
      table_options: {
        handler () {
          //this.load()
        },
        deep: true,
      },
    },
    mounted: function () {
      var insurance_settings = this.$store.state.settings.filter(a=>a.type == 'insurance')[0]
      if (insurance_settings) {
        this.dialog.event_group.period = insurance_settings.data.filter(a=>a.key == 'period')[0].value || 10
      }
      
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      this.select.insurance_product = [
        {
          value: 0,
          text: 'Нет продукта'
        }
      ]
       this.dict.insurance_product[0] = 'Нет продукта'
      for (let x in this.$store.state.dict.insurance_product) {
        if (this.$store.state.dict.insurance_product[x].active == 1) {
          var insurer = {}
          for (let y in this.$store.state.dict.insurer) {
            if (this.$store.state.dict.insurer[y].key == this.$store.state.dict.insurance_product[x].insurer) {
              console.log(this.$store.state.dict.insurer[y].key, this.$store.state.dict.insurance_product[x].insurer)
              insurer.value = Number(y),
              insurer.name = this.$store.state.dict.insurer[y].name
              break;
            }
          }
          this.select.insurance_product.push({
            value: Number(x),
            text: this.$store.state.dict.insurance_product[x].name,
            color: this.$store.state.dict.insurance_product[x].color,
            insurer: insurer
          })
          this.dict.insurance_product[Number(x)] = this.$store.state.dict.insurance_product[x].name
          this.dict.insurance_product_color[Number(x)] = this.$store.state.dict.insurance_product[x].color
        }
      }
      for (let x in this.$store.state.dict.insurer) {
        this.select.insurer.push({ value: Number(x), text: this.$store.state.dict.insurer[x].name })
      }
       this.axios.post('/api/user/get/', {})
          .then(response => {
            if (!response.data.error) {              
              for (let x in response.data.data) {
                response.data.data[x].full_name = (response.data.data[x].surname || '') + ' ' + response.data.data[x].name + ' ' + (response.data.data[x].patronymic || '')
              }
              this.select.users = response.data.data
              this.select.user = [{value: '0', text: 'Система'}]
              for (let x in response.data.data) {
                if (response.data.data[x].role == 1 || response.data.data[x].role == 2 || response.data.data[x].role == 3)
                  this.select.user.push({text:  response.data.data[x].full_name, value: response.data.data[x].id})
              }
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
    },
    methods: {
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      format: function(date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_full: function(date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      formatName: function(user) {
        let result = "";
        if (user.surname) {
          result = user.surname;
          if (user.name) {
            result += ' ' + user.name.charAt(0).toUpperCase() + '.';
             if (user.patronymic) {
              result += ' ' + user.patronymic.charAt(0).toUpperCase() + '.';
            } 
          }
        } else {
          if (user.name) {
            result = user.name;
          } 
        }
        return result;
      },
      row_click: function(item) {
        if (this.choose) {
          if (!this.multiple) {
            this.$emit('select', [item])
          }
        }
      },
      insurance_close: function() {
        this.dialog.insurance.show = false;
        this.load()
      },
      show_insurance_view_dialog: function (data, index) {
        this.dialog.insurance.index = index
        this.dialog.insurance.data = data
        this.dialog.insurance.create = false
        this.dialog.insurance.change = false
        this.dialog.insurance.view = true
        this.dialog.insurance.show = true
      },
      show_insurance_create_dialog: function () {
        this.dialog.insurance.data = null
        this.dialog.insurance.create = true
        this.dialog.insurance.change = false
        this.dialog.insurance.view = false
        this.dialog.insurance.show = true
      },
      create_insurance_events: function () {
        this.axios.post('/api/common/insurance/event', {
          period: this.dialog.event_group.period,
          users: this.dialog.event_group.users,
          date: this.dialog.event_group.date,
          interval: this.dialog.event_group.interval
        })
          .then(result => {
            this.dialog.event_group.show = false
            this.$store.commit('snackbar', 'Успешно')
          })
          .catch(e => {
            this.dialog.event_group.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load: function () {
        if (!this.valid) return
        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        this.form.page = page
        this.form.limit = itemsPerPage
        this.axios.post('/api/common/insurance/list', this.form)
          .then(result => {
            this.overlay = false
            this.form.id = ""
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].doc = result.data.data[x].doc || {}
                if (result.data.data[x].insurer>0) result.data.data[x].insurer_text = this.$store.state.dict.insurer[result.data.data[x].insurer].name
                if (result.data.data[x].kasko) result.data.data[x].kasko_text = 'Есть'
                else result.data.data[x].kasko_text = 'Нет'
                result.data.data[x].doc.date_text = moment(result.data.data[x].doc.date).format('DD.MM.YYYY')
              }
              this.items = result.data.data
            }
            this.total = result.data.total
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            this.form.id = ""
            console.error(e)
          })
      },
    },
  }
</script>
